import axios from "@/utils/axios";
import {
  AxiosError,
  CreatorResponseType,
  loginResponseType,
} from "@/types/global";
import { toast } from "react-toastify";
import { getErrorMessage } from "@/utils/helper";
import Axios, { AxiosResponse } from "axios";

const AxiosInstance = Axios.create({
  baseURL: process.env.NEXT_PUBLIC_WEB_BFF_SERVER || "",
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

export async function registerUser(body: {
  loginType: string;
  walletAddress: string;
  timestamp: number;
  signature: string;
}): Promise<loginResponseType | undefined> {
  try {
    const response = await axios.post(`users/register-wallet`, body);
    return response.data;
  } catch (e) {
    // const errorMsg = getErrorMessage(e as AxiosError);
    // toast.error(errorMsg, {
    //   position: "top-right",
    // });
  }
}
export async function fetchMyDetails(): Promise<
  CreatorResponseType | undefined
> {
  try {
    const response = await axios.get(`users/v2/co/validate-user`);
    return response.data;
  } catch (e) {
    const errorMsg = getErrorMessage(e as AxiosError);
    toast.error(errorMsg, {
      position: "top-right",
    });
  }
}

export const getNonAuthToken = async () => {
  try {
    const data: AxiosResponse<string> = await AxiosInstance.get(
      "/users/non-auth"
    );
    return data?.data;
  } catch (error) {
    const token =
      "eyJhbGciOiJIUzI1NiJ9.YWU1NTBkOGNmN2MzNGFiOTUyZjA2MDY3MTg5MWYwZjU6OThiZmM3YjIwMmJkOGE1OTdjM2Q5N2VhODRhNGNmOTczYzZlMTkyZjMyYmI2ZGM5YTI2MWUxNDQ4ODk2NGY3Mzg2ZjZhMDIyYmZkYmMwZmI2OWZmYmE0NTJhZGJlZGViOWZiNzg2YmZhNzBmMDdmM2UyMWZkN2NlYWE1OTEzZTVkYjYxMWM0NjZmMjA5ODJmNTA3ZWEzMTRhNjBiZDVhMDlkZTg4ZTFlMDE2NWU4OGZkNWQ5Y2E0YzViYjZiYTJhZDllOWJkYjFjN2RiYTQ4Y2Y5NjMzMjk1ZDQzOWJiNDU4NWU4NjhkNGQ3ZTQ1ZGU2YjAxYmMwZjNhYzU2ZGQwZjJlYTkxNTZkMzc0NjVlY2NlN2E1ZDRlNjYyNzViNmRl.vjyi6Wf4TdQ8afUoGVhnvL69hqhZ_ApOAsf6KQy_W0o";
    // return token;
    // return token3;
    // throw error;
  }
};

export const fetchStreamsWithId = async (id: string | number) => {
  try {
    const data: AxiosResponse<string> = await AxiosInstance.post(
      `/room/roomDetail?roomId=${id}&roomType=live`
    );
    return data?.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
export async function fetchUserDetails(
  key: string
): Promise<CreatorResponseType | undefined> {
  try {
    const response = await axios.post(`users/co/get-profile`, { u_add: key });
    return response.data;
  } catch (e) {
    const errorMsg = getErrorMessage(e as AxiosError);
    toast.error(errorMsg, {
      position: "top-right",
    });
  }
}

export async function followUser(key: string): Promise<
  | {
      code: number;
      message: string;
      data: {
        followId: number;
      };
    }
  | undefined
> {
  try {
    const response = await axios.post(`users/v2/co/follow`, { u_add: key });
    return response.data;
  } catch (e) {
    const errorMsg = getErrorMessage(e as AxiosError);
    toast.error(errorMsg, {
      position: "top-right",
    });
  }
}
